import React from 'react';
import DragList from './DragList/DragList';

const TasksBoard = ({
  // onAddTask,
  // onTaskSelect,
  tasks,
}) => {
  return (
    <DragList
      tasks={tasks}
    />
  );
};

export default TasksBoard;
